<template>
  <form name="upload" class="hidden visually-hidden">
    <input
      id="uploadPicker"
      type="file"
      name="file"
      @change="fileSelected"
    >
  </form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'InvisibleUploadForm',
  methods: {
    ...mapActions(['upload']),
    fileSelected(evt) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.upload(Array.from(evt.target.files));
    },
  },
};
</script>

<style scoped></style>
